import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { featuredPeopleQueryKeys } from './query-keys';

type FeaturedPeopleBatchActions = 'delete';

type FeaturedPeopleBatchItem = {
  id: string;
};

export type TBatchFeaturedPeopleParams = {
  action: FeaturedPeopleBatchActions;
  items: FeaturedPeopleBatchItem[];
};

export function batchFeaturedPeople(body: TBatchFeaturedPeopleParams): Promise<unknown> {
  return mediaManagerClient.post(`/api/v1/peoples/batch`, body);
}

type MutationFn = typeof batchFeaturedPeople;

type UseBatchFeaturedPeopleParams = {
  config?: MutationConfig<MutationFn>;
};

export function useBatchFeaturedPeople({ config }: UseBatchFeaturedPeopleParams = {}) {
  const { t } = useTranslation();

  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);

      if (status === 404) {
        addErrorNotification(t('Una de las personas de interés no existe'));
      } else {
        addErrorNotification(t('No se han podido eliminar las personas de interés'));
        console.error(error);
      }
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: featuredPeopleQueryKeys.all });
      addSuccessNotification(t('Las personas de interés se han eliminado correctamente'));
    },
    ...config,
    mutationFn: batchFeaturedPeople,
  });
}
